import { gql } from '@apollo/client';

export const GET_SALES_ORDER_ATTACHMENT_DOWNLOAD_URL = gql`
  query GetSalesOrderAttachmentDownloadUrl(
    $orderId: String!
    $attachmentId: String!
  ) {
    salesOrderAttachmentDownloadUrl(
      orderId: $orderId
      attachmentId: $attachmentId
    ) {
      preSignedUrl
    }
  }
`;
